import { useState } from 'react';
import { useInstallPrompt } from '../../hooks/useInstallPrompt';
import { ListItem } from '../lists';
import { Icon } from './Icon';
import styles from './InstallButton.module.css';

export function InstallButton() {
  const { canShow, canInstallDirectly, platform, triggerInstall } = useInstallPrompt();
  const [showInstructions, setShowInstructions] = useState(false);

  if (!canShow) return null;

  const handlePress = () => {
    if (canInstallDirectly) {
      triggerInstall();
    } else {
      setShowInstructions(true);
    }
  };

  return (
    <>
      <ListItem
        title="Add to Homescreen"
        IconComponent={<Icon name="download" backgroundColor="var(--toc-blue)" iconColor="white" />}
        onPress={handlePress}
      />

      {showInstructions && (
        <div className={styles.overlay} onClick={() => setShowInstructions(false)}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <h3 className={styles.title}>Add to Homescreen</h3>

            {platform === 'ios' && (
              <ol className={styles.steps}>
                <li>Tap the <strong>Share</strong> button <span className={styles.shareIcon}>↑</span> at the bottom of the screen</li>
                <li>Scroll down and tap <strong>"Add to Home Screen"</strong></li>
                <li>Tap <strong>"Add"</strong> to confirm</li>
              </ol>
            )}

            {platform === 'safari-desktop' && (
              <ol className={styles.steps}>
                <li>Click the <strong>Share</strong> button <span className={styles.shareIcon}>↑</span> in the Safari toolbar</li>
                <li>Select <strong>"Add to Dock"</strong> or <strong>"Add to Home Screen"</strong></li>
              </ol>
            )}

            {platform === 'standard' && (
              <ol className={styles.steps}>
                <li>Open your browser menu (three dots)</li>
                <li>Select <strong>"Install App"</strong> or <strong>"Add to Home Screen"</strong></li>
              </ol>
            )}

            <button className={styles.closeButton} onClick={() => setShowInstructions(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default InstallButton;
